<template>
    <div>
        <div v-for="(item, i) in answer" :key="i" class="multi">
            <label v-if="item.etc" class="etc_label label-checkbox">
                <input
                    type="checkbox"
                    class="multi__pick"
                    :name="`q_${mode}_${no_plus}`"
                    value="etc"
                    @click="e => focusHandler(e, i)"
                />

                <div class="label-input-visible">
                    <div class="label-input-visible__checkbox" />
                    <div class="label-input-visible__answer">기타</div>
                </div>

                <div>
                    <input type="text" v-model="_etc" ref="etc_input_single" :disabled="disabled_check" />
                </div>
            </label>

            <label class="label-checkbox" @click="clickHandler(i)" v-else>
                <input
                    type="checkbox"
                    class="multi__pick"
                    :name="`q_${mode}_${no_plus}`"
                    :value="i"
                    :checked="findCheckedValue(i)"
                    :disabled="getMaxCount(i)"
                    @change="changeHandler(i)"
                />

                <div class="label-input-visible">
                    <div class="label-input-visible__checkbox" />
                    <div class="label-input-visible__answer" v-html="item.value" />
                    <div class="label-input-visible__first-come" v-if="firstComeByAnswer" v-html="getFirstComeRemained(item)"></div>
                </div>

                <div v-if="item.imgUrl" class="multi__img">
                    <img :src="item.imgUrl" />
                </div>
            </label>
        </div>
    </div>
</template>

<script>
import { hasOwnProperty } from "@/lib/core";

export default {
    name: "MultiSelector",
    props: ["answer", "no", "mode", "parentNo", "type", "value", "isInput", "firstComeByAnswer", "onChange", "onError", "onEtcChange", "countOfChoices"],
    computed: {
        _etc: {
            get() {
                if (!this.disabled_check) {
                    const index = this.findEtcIndex();

                    return this.value[index].etc;
                } else {
                    return "";
                }
            },
            set(value) {
                const { no, parentNo, type } = this;
                this.onEtcChange({ no, parentNo, value, type });
            }
        },
        no_plus() {
            return this.no + 1;
        },
        disabled_check() {
            const find = this.findEtcIndex();

            if (find === -1) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {

        changeHandler(value) {
            const { no, type, parentNo } = this;
            this.onChange({ no, parentNo, value, type });
        },
        clickHandler(value) {
            const outOfRangeError = "answer_out_of_range";
            const outOfFirstComeError = "answer_out_of_first_come";

            if(this.firstComeByAnswer && this.answer[value].remainingCount === 0) {
                this.onError(outOfFirstComeError);
            } else if (this.getMaxCount(value)) {
                this.onError(outOfRangeError);
            }
        },
        focusHandler(e) {
            const { value } = e.target;
            const { no, type, parentNo } = this;
            this.onChange({ no, parentNo, value, type });

            setTimeout(() => {
                this.$refs.etc_input_single[0].focus();
            }, 100);
        },

        findEtcIndex() {
            const find = this.value.findIndex(v => typeof v === "object" && hasOwnProperty(v, "etc"));

            return find;
        },

        findCheckedValue(value) {
            const find = this.value.findIndex(d => d === value);
            return find === -1 ? false : true;
        },

        getMaxCount(value) {
            // 보기별 선착순 마감
            if(this.firstComeByAnswer && this.answer[value].remainingCount === 0) {
                return true;
            }

            if(this.countOfChoices === 0) {
                return false;
            }

            // 최대 선택 개수 초과
            return this.countOfChoices <= this.value.length && this.value.indexOf(value) === -1;
        },

        getFirstComeRemained(item) {
            if(item.firstCome && item.firstCome !== 0) {
                if(item.remainingCount !== 0) {
                    return item.remainingCount + "명 남음";
                } else {
                    return "선착순 마감";
                }
            } else {
                return "선착순 제한 없음";
            }
        }
    }
};
</script>

<style lang="scss">
.multi {
    font-size: 0;

    & + & {
        margin-top: 16px;
    }

    label {
        cursor: pointer;
        display: inline-block;
    }

    .etc_label > div input {
        margin-top: 8px;
    }

    &__pick {
        &:checked {
            & + .single__img {
                border: 2px solid #f4b643;
            }
        }
    }

    &__img {
        width: 260px;
        height: 200px;
        text-align: center;
        margin-bottom: 20px;
        border: 2px solid #ffffff;
        padding: 16px;

        img {
            height: 100%;
            display: inline-block;
            border: 0;
        }
    }
}
</style>
